import React, { RefObject } from 'react'
import cx from 'classnames'

import cm from './BorderLoader.module.css'

interface BorderLoaderProps {
  isBusy?: boolean
  position?: 'static' | 'absolute'

  gradientClassName?: string

  children?: React.ReactNode
  gradientRef?: RefObject<HTMLDivElement>
  backgroundRef?: RefObject<HTMLDivElement>
}

export const BorderLoader = ({
  isBusy = false,
  position = 'absolute',

  gradientClassName,

  children,
  gradientRef,
  backgroundRef,
}: BorderLoaderProps) => {
  return (
    <div
      className={cx(
        cm.gradientBackground,
        {
          [cm.gradientBackground__busy]: isBusy,
          [cm.gradientBackground_position_absolute]: position === 'absolute',
        },
        gradientClassName,
      )}
      ref={gradientRef}
    >
      <div
        className={cx(cm.clip, isBusy && cm.clip__busy)}
        ref={backgroundRef}
        data-test-id="ai-assistant-loader"
        data-status={isBusy ? 'busy' : 'idle'}
      >
        {children}
      </div>
    </div>
  )
}
